import { CustomerFindingStatusSchema } from '@terra/shared-contracts-findings';
import type { CustomerFindingStatus } from '../../types';

export const shouldOpenStatusReasonDialog = ({
  currentStatus,
  nextStatus,
}: {
  currentStatus: CustomerFindingStatus;
  nextStatus: CustomerFindingStatus;
}): boolean =>
  nextStatus !== currentStatus &&
  nextStatus !== CustomerFindingStatusSchema.enum.InProgress &&
  nextStatus !== CustomerFindingStatusSchema.enum.Resolved;
